import React from "react"
import EmailHeader from "./EmailHeader"
import RichTextEditor from "../RichTextEditor/RichTextEditor"
import Cookies from 'js-cookie'
import ErrorHelper from "../Errors/ErrorHelper"
import EmailBuilderActions from "./actions/EmailBuilderActions"

export default class DesignEditor extends React.Component{

  constructor(props) {
    super(props);

    this.state = {
      focused: false,
      body: this.props.email && this.props.email.body ? this.props.email.body : '',
      loading: true
    }

    this.onChange = this.onChange.bind(this)
    this.disableLoading = this.disableLoading.bind(this)
  }

  componentDidUpdate() {
    var help_type = 'reservation'
    if (this.props.email.email_type == 'campaign') {
      help_type = 'campaign'
    } else if (this.props.reservation_segment_email_events.includes(this.props.email.lifecycle_event)) {
      help_type = 'room';
    } else if (this.props.email.lifecycle_event && this.props.email.lifecycle_event.includes('order')) {
      help_type = 'order'
    } else if (this.props.email.lifecycle_event && this.props.email.lifecycle_event.includes('voucher')) {
      help_type = 'voucher'
    }

    Cookies.set('help_type', help_type);
    Cookies.set('help_type_name', this.props.email.lifecycle_event || this.props.email.email_type);
  }

  render() {
    return (
      <div className="editorWrapper">

        <EmailHeader {...this.props} {...this.state} />

        <div className="editor" style={this.state.style} ref="inner">
          <RichTextEditor body={this.state.body} onChange={this.onChange} className={ErrorHelper.renderFieldClasses('body', this.props.errors)} merge_tag_button={true} image_button={true} auto_resize={true} images_data_table_path={this.props.images_data_table_path} disableLoading={this.disableLoading} folio_item_types={this.props.folio_item_types} survey_forms={this.props.survey_forms} agreement_forms={this.props.agreement_forms} system_data={this.props.email ? this.props.email.system_data : null}/>
          {ErrorHelper.renderFieldErrors('body', this.props.errors)}
          <input
            type="hidden"
            name="email[body]"
            value={this.props.email && this.props.email.body ? this.props.email.body : ''}/>
        </div>
        {this.state.loading ? <div className="loadingOverlay"><div className="spinner"></div></div> : null}
      </div>
    );
  }

  onChange(html) {
    EmailBuilderActions.setBody(html);
    if (this.props.onChange) {
      this.props.onChange(html);
    }
  }

  disableLoading(){
    this.setState({loading: false})
  }
};
